import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import React, { useState } from 'react';
import { useGlobalModalContext } from '../../../../components/GlobalModal';
import useModalErrorHandler from '../../../../hooks/modal/useModalErrorHandler';

interface ConfirmRemoveIssuersModalProps {
  onConfirm: () => void;
  isMultipleIssuers: boolean;
}

const ConfirmRemoveIssuersModal = ({
  isMultipleIssuers,
  onConfirm,
}: ConfirmRemoveIssuersModalProps): React.ReactElement => {
  const { closeModal, setError, store } = useGlobalModalContext();
  const [isRemoving, setIsRemoving] = useState(false);
  const isModalCloseable = !isRemoving;
  useModalErrorHandler(setIsRemoving);

  const renderFooter = () => (
    <>
      <Button
        disabled={isRemoving}
        dataTestId="remove-issuers-cancel-button"
        onClick={closeModal}
        mode={ButtonMode.SECONDARY}
      >
        Cancel
      </Button>
      <Button
        disabled={isRemoving}
        loading={isRemoving}
        onClick={() => {
          setIsRemoving(true);
          setError('');
          onConfirm();
        }}
        dataTestId="remove-issuers-confirm-button"
        mode={ButtonMode.PRIMARY}
      >
        Remove
      </Button>
    </>
  );

  return (
    <Modal
      width={ModalWidth.Small}
      closeOnEscape={isModalCloseable}
      closeOnDimmerClick={isModalCloseable}
      open
      onClose={closeModal}
      headerTitle={isMultipleIssuers ? 'Remove Issuers' : 'Remove Issuer'}
      footer={renderFooter()}
      error={store.props.error}
      closeOnButtonClick={isModalCloseable}
    >
      <p>
        {isMultipleIssuers
          ? 'Are you sure you want to remove the selected issuers from watchlist?'
          : 'Are you sure you want to remove the selected issuer from watchlist?'}
      </p>
    </Modal>
  );
};

export default ConfirmRemoveIssuersModal;
